import { useContext } from "react"
import { ListContext } from "../../providers/contexts/ListContext";

export const useList = () => {
    return useContext(ListContext);
}